import { Pipe, PipeTransform } from '@angular/core';
import { AnswerSearch } from '../models/recent-search';
import { SearchType } from '../enums/search-type';

@Pipe({
  name: 'sliceArrayItems',
  pure: true,
})
export class SliceArrayItemsPipe implements PipeTransform {
  transform(
    items: AnswerSearch[] | undefined,
    searchType: SearchType | undefined,
    showAllResults: boolean | undefined,
  ): AnswerSearch[] {
    if (!items) {
      return [];
    }
    if (showAllResults) {
      return items;
    }
    if (searchType === SearchType.RECENT) {
      return items.slice(0, 5);
    }
    return items;
  }
}
